import { OBJ } from 'constants';
import { API_ENDPOINTS } from 'constants';
import { useComponentDetails } from 'hooks/useComponentDetails';
import { useList } from 'hooks/useList';
import React, { createContext, useContext, useMemo, useState } from 'react';

const CampaignContext = createContext();

export const CampaignProvider = ({ selectedItem, setSelectedItem, context, list, children }) => {
        const { data: event, saveData: saveEvent, saveKey: saveEventKey, isLoading: isLoadingEvent, error: errorEvent, saveError: saveErrorEvent, success: successEvent, refetch: refetchEvent, toolbar} = useComponentDetails(API_ENDPOINTS.EVENTS.ITEM(selectedItem.id), list)
        const { list: participantList, setAndSave: setAndSaveParticipants, setAndSaveLineKey: saveParticipantKey, 
            isLoading: isLoadingParticipants, error: errorParticipants, refetch: refetchParticipants } = useList(OBJ.EVENT_PARTICIPANTS, null, null, null, JSON.stringify({event_id: selectedItem.id, filter_tree_id: null}), null, {sortBy: 'planned_date', sortOrder: 'asc', per_page: 10000})

        const value = useMemo(() => ({ 
            toolbar,
            selectedItem, setSelectedItem, context, list,
            event, saveEvent, saveEventKey, isLoadingEvent, errorEvent, saveErrorEvent, successEvent, refetchEvent, 
            participantList, setAndSaveParticipants, saveParticipantKey, isLoadingParticipants, errorParticipants, refetchParticipants
        }), [toolbar,
            selectedItem, setSelectedItem, context, list,
            event, saveEvent, saveEventKey, isLoadingEvent, errorEvent, 
            saveErrorEvent, successEvent, refetchEvent, 
            participantList, setAndSaveParticipants, saveParticipantKey, isLoadingParticipants, 
            errorParticipants, refetchParticipants,
        ]);

        return (
            <CampaignContext.Provider value={value}>
            {children}
            </CampaignContext.Provider>
        );
    };

    export const useCampaignContext = () => {
        const context = useContext(CampaignContext);
        if (!context) {
            throw new Error('useCampaignContext must be used within a CampaignProvider');
        }
    return context;
};
